import { render, staticRenderFns } from "./UnAuthorizedView.vue?vue&type=template&id=6068eacc&scoped=true&funtional=true&"
import script from "./UnAuthorizedView.vue?vue&type=script&lang=js&"
export * from "./UnAuthorizedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6068eacc",
  null
  
)

export default component.exports